module.exports = __webpack_public_path__ + "static/img/right-top-row-1.f684be17.webp";